<template>
    <div class="container">
        <div class="row" v-if="user.user_type_id!=3 || (user.user_type_id==3 && user.is_certyficated)">
            <div class="col-lg-4">
                <h2 class="h h--2 h--dark">Wypożyczalnia narzędzi</h2>
                <p class="paragraph">Wypożyczalnia jest dostępna dla Instalatorów zarejestrowanych w programie Geberit Pro.</p>
                <p class="paragraph">Maksymalny czas bezpłatnego wypożyczenia narzędzi to 7 dni roboczych.</p>
                <p class="paragraph">Obsługą wypożyczalni zajmuje się partner zewnętrzny Geberit.</p>
                <p class="paragraph">Narzędzia wysyłane są i odbierane po okresie wypożyczenia przez firmę kurierską.</p>
            </div>
            <div class="col-lg-8">
                <div class="row prize">
                    <router-link :to="{name: 'Tools'}" class="prize__close"></router-link>
                    <div class="col-md-5">
                        <img v-auth-image="'/photos/'+ tool.photos[0].id + '?thumbnail=300'" alt="" class="prize__img" v-if="tool.photos && tool.photos.length > 0" />
                        <p class="paragraph">Dostępnych sztuk: {{ tool.quantity_available }}</p>
                        <p class="paragraph paragraph--red" v-if="tool.quantity_available <= 0">Narzędzie wypożyczone. <span v-if="tool.returning_date">Dostępne od {{ tool.returning_date }}</span></p>
                    </div>
                    <div class="col-md-7">
                        <h3 class="prize__name">{{ tool.name }}</h3>
                        <p class="prize__desc">{{ tool.description }}</p>
                        <div class="">
                            <b-form-select v-model="modifiers[modifier[0].type.name]" :options="options(modifier)" class="prize__modifier" v-for="modifier in tool.modifiers" :key="modifier.id">
                                <template slot="first">
                                    <option :value="null" disabled>Wybierz {{ modifier[0].type.name }}</option>
                                </template>
                            </b-form-select>
                        </div>
                        <div class="clearfix"></div>
                        <form method="post" class="form" @submit="order">
                            <div class="form__input-container">
                                <input type="text" name="quantity" v-model="quantity" class="form__input" placeholder="Liczba sztuk" required>
                            </div>
                            <div class="form__input-container">
                                <flat-pickr v-model="date" :config="config" placeholder="Termin oddania"></flat-pickr>
                            </div>
                            <div class="form__input-container">
                                <textarea name="notes" v-model="notes" class="form__input" placeholder="Uwagi"></textarea>
                            </div>
                            <button class="button button--small button--filled-blue prize__order-button" :disabled="submitted || tool.quantity_available <= 0" type="submit">Wypożycz &raquo;</button>                            
                        </form>
                    </div>
                </div>
            </div>
        </div>
        <page-box-set-widget></page-box-set-widget>
    </div>
</template>

<script>
import Vue from 'vue'
import flatPickr from 'vue-flatpickr-component'
import {Polish} from 'flatpickr/dist/l10n/pl.js'
import 'flatpickr/dist/flatpickr.css';

export default {
  name: 'ToolComponent',
    components: {
        flatPickr
    },
  data () {
    return {
      tool: [],
      modifiers: [],
      selected: null,
      submitted: false,
      date: null,
      quantity: '',
      newAddress: false,
      voivodeship: '',
      city: '',
      postal_code: '',
      address: '',
      notes: '',
      // Get more form https://chmln.github.io/flatpickr/options/
      config: {
        wrap: true, // set wrap to true only when using 'input-group'
        altFormat: 'd.m.Y h:i',
        altInput: true,
        dateFormat: 'd.m.Y h:i',
        locale: Polish, // locale for this instance only ,
        enableTime: true,  
        time_24hr: true
       },                
    }
  },
  computed: {
    user() {
      return this.$store.state.user
    }
  },
  mounted: function() {
    if( !this.user || this.user.id != 1 ) {
        this.$gtag.pageview({
            page_path: '/wypozyczalnia-narzedzi/' + this.$route.params.id,
        })
    }
  },
  beforeRouteEnter(to, from, next) {
    /**
     * Get current user object.
     */
    Vue.axios({
      method: 'get',
      url: '/tools/' + to.params.id
    })
    .then(response => {   
        var mods = {}
        Object.keys(response.data.data.tool.modifiers).forEach(function(item, index) {
            mods[item] = null
        })

        next(vm => {
            vm.tool = response.data.data.tool
            vm.modifiers = mods
        })
    })
    .catch(error => next(false))
  },
  methods: {
    options: function (values) {
        const options = values.map(o => {
            return {
                value: o.id,
                text: o.name
            };
        });

        return options;
    },
    order: function(e) {
        e.preventDefault()

        var _this = this
        var tool_id = this.$route.params.id
        this.submitted = true
        
        for( var item in this.modifiers ) {
            if( !this.modifiers[item] ) {
                _this.submitted = false
                return this.$toaster.error("Wybierz " + item + " narzędzia")
            }
        }

        if( !this.date ) {
            this.submitted = false
            return this.$toaster.error("Wybierz termin oddania")
        }

        var data = {
            tools: [
                {
                    id: tool_id,
                    quantity: this.quantity,
                    modifiers: this.modifiers
                }
            ],
            end_date: this.date,
            additional_info: this.notes
        }

        Vue.axios({
            method: 'post',
            url: '/tools/order',
            data: data
        })
        .then(response => {
            _this.tool.quantity_available -= this.quantity
            this.$toaster.success(response.data.message)
            _this.submitted = false
            _this.date = null,
            _this.quantity = '',
            _this.newAddress = false,
            _this.voivodeship = '',
            _this.city        = '',
            _this.address     = '',
            _this.postal_code = '',
            _this.notes = ''
        })
        .catch(error => {
            this.$toaster.error(error.response.data.message)
            _this.submitted = false
        })
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/app/home/tools/ToolComponent.vue